import { useMutation } from '@tanstack/react-query';

import { DocumentFilter, SaveFilterFormValues } from '../../../../../types';
import { handleError } from '../../../../../utils/admin';
import { DocumentParams } from '../../../../documents/types/DocumentParams';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { saveFilter } from '../../requests/saveFilter';

type UseSaveFilterOptions = {
  onSuccess?: (filter: DocumentFilter | undefined) => void;
};

export const useSaveFilter = (
  params?: DocumentParams,
  options?: UseSaveFilterOptions,
) => {
  const { constructPost } = useRequestConstructor();

  const { mutateAsync, ...rest } = useMutation({
    mutationFn: (formValues: SaveFilterFormValues) =>
      saveFilter(constructPost, formValues, params).then(
        (response) => response?.data,
      ),
    onSuccess: options?.onSuccess,
    onError: () => handleError('Failed to save filter'),
  });

  return { saveFilter: mutateAsync, ...rest };
};
